import { Variant } from "@/types/types.ts";

type VariantService = NonNullable<Variant["services"]>[number];
type IncludedGuaranteeService = Extract<
  VariantService,
  { __typename: "IncludedGuarantee" }
>;

export type ExtendedWarrantyService = Extract<
  VariantService,
  { __typename: "ExtendedWarranty" }
>;

// todo - move to global utils for C&C
export const formatOrderByTime = (time: string): string => {
  const [h, m] = time.split(":").map((t) => parseInt(t, 10));
  const hours = h || 0;
  const minutes = m || 0;
  const hour12 = hours % 12 || 12;
  const suffix = hours >= 12 ? "pm" : "am";
  return minutes === 0
    ? `${hour12}${suffix}`
    : `${hour12}:${minutes.toString().padStart(2, "0")}${suffix}`;
};

export function isIncludedGuarantee(
  service: VariantService,
): service is IncludedGuaranteeService {
  return service.__typename === "IncludedGuarantee";
}

export function isProtectPlusExtendedWarranty(
  service: VariantService,
): service is ExtendedWarrantyService {
  return (
    service.__typename === "ExtendedWarranty" &&
    service.title.includes("Protect Plus")
  );
}
